
import { NgModule } from '@angular/core';

import { ConnectionTypesSharedModule } from 'app/connection-types/connection-types-shared.module';
import { FieldSharedModule } from 'app/field-shared/field-shared.module';
import { SharedModule } from 'shared/shared.module';

import {
  ExportSpecializedComponent
} from './components/export-specialized/export-specialized.component';
import { ExportStandardComponent } from './components/export-standard/export-standard.component';
import { ExportComponent } from './components/export.component';
import { ExportDialog } from './dialogs/export.dialog';

const Dialogs = [
  ExportDialog
];

@NgModule({
  imports: [
    SharedModule,
    FieldSharedModule,
    ConnectionTypesSharedModule
  ],
  declarations: [
    ExportComponent,
    ExportStandardComponent,
    ExportSpecializedComponent,
    ...Dialogs
  ],
  providers: [],
  exports: [
    ExportComponent,
    ...Dialogs,

  ]
})
export class ExportModule { }
